{
  "releaseName": "Setenta complicado",
  "versionNumber": "30102026.308"
}
